// TRANSLATE
import WhatsNext from "./WhatsNext/WhatsNext";
import ThankYouFooter from "./ThankYouFooter/ThankYouFooter";

type Props = {
  visible?: boolean;
};

export function WhatsNextAndFooter({ visible = true }: Props) {
  if (!visible) return null;

  return (
    <>
      <WhatsNext />
      <ThankYouFooter />
    </>
  );
}
